import React from 'react';

import Icon from '../icon2';

import './icon2__warning-triangle.scss';

export default function Icon2WarningTriangle(props) {
    return (
        <Icon name="warning-triangle" viewBox="0 0 20 20" {...props}>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M11.756 4.042l6 11C18.483 16.375 17.518 18 16 18H4c-1.518 0-2.483-1.625-1.756-2.958l6-11c.758-1.39 2.754-1.39 3.512 0z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
                <path
                    d="M10.5 15h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm0-3h-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5z"
                    fill="#FFF"
                />
            </g>
        </Icon>
    );
}
/* eslint-enable max-len */
